export default "__VITE_ASSET__5k75MV8N__"